import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$window, $body} from '../Constants';

/**
 * Tiles
 */
class Tiles extends HtmlElement {
    onReady() {
        this.tiles = this.getTiles();

        if($window.width() >= 780) {
            this.equalizeTiles([this.tiles[0], this.tiles[5]]);
        }else {
            this.removeHeight([this.tiles[0], this.tiles[5]]);
        }
    }

    onResize() {
        if($window.width() >= 780) {
            this.equalizeTiles([this.tiles[0], this.tiles[5]]);
        }else {
            this.removeHeight([this.tiles[0], this.tiles[5]]);
        }
    }

    getTiles() {
        let tiles = [];
        let _self = this;

        this.$element.find('.tile').each(function() {
           tiles.push($(this));

           if(_self.tileContainsImage($(this))) {
               $(this).addClass('containsImage');
           }
        });

        return tiles;
    }

    equalizeTiles(tilesToEqualize) {
        let biggestHeight = this.getBiggestHeight(tilesToEqualize);

        for(let i = 0; i < tilesToEqualize.length; i++) {
            tilesToEqualize[i].addClass('tileEqualized').css('height', biggestHeight);
        }
    }

    removeHeight(tiles) {
        for(let i = 0; i < tiles.length; i++) {
            tiles[i].css('height', '');
        }
    }

    tileContainsImage($tile) {
        return $tile.find('img').length > 0;
    }

    getBiggestHeight(tiles) {
        let heights = [];

        for(let i = 0; i < tiles.length; i++) {
            heights.push(tiles[i].outerHeight());
        }

        return Math.max(...heights);
    }
}

export default (new Tiles($body.find('.tiles')));